import React from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';

const YOUTUBE_VIDEO_URL_PREFIX = [
	"https://youtu.be/",
	"https://www.youtube.com/watch?v=",
];

function getYoutubeVideoId(url) {
	for (let i = 0; i < YOUTUBE_VIDEO_URL_PREFIX.length; i++) {
		if (url.startsWith(YOUTUBE_VIDEO_URL_PREFIX[i])) {
			return url.substring(YOUTUBE_VIDEO_URL_PREFIX[i].length);
		}
	}
	return null;
}

function getYoutubeVideoUrl(videoId) {
	if (!videoId) return "";
	return YOUTUBE_VIDEO_URL_PREFIX[0] + videoId;
}

function YoutubeInfoInput({value, onUpdate}) {
	const [url,setUrl] = React.useState(getYoutubeVideoUrl(value.videoId));

	function handleUrlChange(e) {
		let url = e.target.value;
		console.log("handleUrlChange: url = " + url);
		setUrl(url);
	}

	async function handleDone() {
		if (onUpdate) {
			onUpdate({
				videoId: getYoutubeVideoId(url)
			});
		}
	}

	return (
		<Box
			display='flex'
			flexDirection='column'
			justifyContent='center'
			alignItems='flex-start'
			sx={{
				width: `${320/360 * 100}vw`,
				borderWidth: `${0.6/360 * 100}vw`,
				borderColor: '#e8e8e8',
				borderStyle: 'solid',
				borderRadius: `${10/360 * 100}vw`,
				boxShadow: `${2/360 * 100}vw ${2/360 * 100}vw ${12/360 * 100}vw 0 #0f000000`,
				marginTop: `${10/360 * 100}vw`,
				padding: `${20/360 * 100}vw`,
			}}
		>
			<Typography
				sx={{
					fontFamily: '노토산스 Bold',
					fontSize: `${14/360 * 100}vw`,
					color: '#171717',
					width: '100%',
				}}
			>
				YouTube URL
			</Typography>
			<TextField
				sx={{
					marginTop: `${10/360 * 100}vw`,
					width: `${280/360 * 100}vw`,
					//height: `${43/360 * 100}vw`,
				}}
				variant="outlined"
				placeholder="https://www.youtube.com/watch?v=_9v7AekODHo"
				type="text"
				value={url}
				onChange={handleUrlChange}
				onContextMenu={e => e.stopPropagation() /* to allow context menu for text edit block */}
			/>
			<Button
				variant="outlined"
				sx={{
					bgcolor: '#6cadff',
					border: `${1/360 * 100}vw solid #6cadff`,
					borderRadius: `${15/360 * 100}vw`,
					width: `${74/360 * 100}vw`,
					height: `${30/360 * 100}vw`,
					marginTop: `${10/360 * 100}vw`,
				}}
				onClick={e => handleDone()}
			>
				<Typography
					fontFamily='노토산스 Bold'
					fontSize={`${14/360 * 100}vw`}
					color='white'
					sx={{margin:'-10px'}}
				>
					반영
				</Typography>
			</Button>
		</Box>
	);
}

export default YoutubeInfoInput;
